import React from 'react';

import Commissions  from 'components/Tvendo/Sale/QuotaBPartner/Commissions/List.js';

export default function () {
  return <Commissions  />;
}